import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'tw-elements';
if (environment.production) {
  enableProdMode();
}
// if(environment.production && environment.mode.prod){
//   const scriptAnalytics = window.document.createElement('script');
//   const scriptEl = window.document.createElement('script');
//   scriptAnalytics.async;
//   scriptAnalytics.src = 'https://www.googletagmanager.com/gtag/js?id=G-9EWC9M2TTH';
//   scriptEl.src = 'assets/js/analytics.min.js';
//   window.document.head.appendChild(scriptAnalytics);
//   window.document.head.appendChild(scriptEl);
// }

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
};


if (document.readyState === 'complete') {
  bootstrap();
  
  
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
  
}

